import { render, staticRenderFns } from "./visits-tool.vue?vue&type=template&id=36e372e4"
import script from "./visits-tool.vue?vue&type=script&lang=js"
export * from "./visits-tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports